const uz = {
  app: {
    name: 'W&M',
    fullName: 'W&M Vending',
    tagline: 'Savdo avtomatlari boshqaruvi',
  },
  common: {
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: 'O‘chirish',
    edit: 'Tahrirlash',
    back: 'Orqaga',
    search: 'Qidirish',
    actions: 'Amallar',
    total: 'Jami',
    all: 'Barchasi',
    refresh: 'Yangilash',
    retry: 'Qayta urinish',
    exportCsv: 'CSV eksport',
    viewAll: 'Barchasini ko‘rish',
    open: 'Ochish',
    more: 'Yana',
    loading: 'Yuklanmoqda…',
    currency: 'so‘m',
    pcs: 'dona',
    days: 'kun',
    noValue: '—',
    optional: 'ixtiyoriy',
  },
  nav: {
    sectionMain: 'Asosiy',
    sectionManage: 'Boshqaruv',
    dashboard: 'Asosiy sahifa',
    checkout: 'Kassa',
    reports: 'Hisobotlar',
    createReport: 'Hisobot yuborish',
    users: 'Xodimlar',
    branches: 'Filiallar',
    products: 'Sklad',
    collapse: 'Yon panelni yig‘ish',
    expand: 'Yon panelni yoyish',
    openMenu: 'Menyuni ochish',
    home: 'Bosh sahifa',
  },
  header: {
    breadcrumb: 'Sahifa yo‘li',
    search: 'Qidirish…',
    searchShortcut: 'Ctrl K',
    notifications: 'Bildirishnomalar',
    noNotifications: 'Yangi bildirishnomalar yo‘q',
    allGood: 'Hammasi joyida',
    lowStockItem: 'Omborda {{count}} dona qoldi',
    outOfStockItem: 'Omborda qolmadi',
    theme: 'Mavzu',
    language: 'Til',
    profile: 'Profil',
    editProfile: 'Profilni tahrirlash',
    logout: 'Chiqish',
    administrator: 'Administrator',
    employee: 'Xodim',
  },
  theme: {
    system: 'Tizim',
    light: 'Yorug‘',
    dark: 'Qorong‘i',
    night: 'Tungi',
  },
  search: {
    placeholder: 'Sahifa, mahsulot, filial yoki xodimni qidiring…',
    pages: 'Sahifalar',
    products: 'Mahsulotlar',
    branches: 'Filiallar',
    users: 'Xodimlar',
    empty: 'Hech narsa topilmadi',
    hintNavigate: 'tanlash',
    hintOpen: 'ochish',
    hintClose: 'yopish',
  },
  filters: {
    period: 'Davr',
    today: 'Bugun',
    yesterday: 'Kecha',
    last7: '7 kun',
    last30: '30 kun',
    thisMonth: 'Joriy oy',
    custom: 'Maxsus davr',
    branch: 'Filial',
    allBranches: 'Barcha filiallar',
    product: 'Mahsulot',
    allProducts: 'Barcha mahsulotlar',
    productsSelected: '{{count}} ta mahsulot',
    startDate: 'Boshlanish sanasi',
    endDate: 'Tugash sanasi',
    reset: 'Filtrlarni tozalash',
  },
  dashboard: {
    title: 'Boshqaruv paneli',
    subtitle: 'Savdo, ombor va filiallar holati bir qarashda',
    kpi: {
      revenue: 'Umumiy tushum',
      today: 'Bugungi tushum',
      units: 'Sotilgan mahsulotlar',
      profit: 'Yalpi foyda',
      avgDaily: 'Kunlik o‘rtacha tushum',
      stock: 'Ombordagi qoldiq',
      lowStock: 'Kam qolgan mahsulotlar',
      branches: 'Savdo qilgan filiallar',
    },
    vsPrevious: 'oldingi davrga nisbatan',
    vsYesterday: 'kechaga nisbatan',
    noComparison: 'Taqqoslash uchun ma’lumot yo‘q',
    skuCount: '{{count}} turdagi mahsulot',
    lowStockHint: '{{count}} dona va undan kam',
    branchesHint: 'jami {{count}} ta filialdan',
    margin: 'Marja: {{value}}',
    daysWithSales: '{{count}} ta savdo kuni',
    productFilterNote: 'Mahsulot filtri qo‘llanmaydi',
    allInStock: 'Barcha mahsulotlar yetarli',
    openReports: 'Batafsil hisobot',
  },
  charts: {
    salesDynamics: 'Savdo dinamikasi',
    salesDynamicsSub: 'Kunlar kesimida, oldingi davr bilan taqqoslash',
    current: 'Joriy davr',
    previous: 'Oldingi davr',
    revenue: 'Tushum',
    profit: 'Foyda',
    units: 'Sotilgan dona',
    cost: 'Tannarx',
    revenueVsCost: 'Tushum va tannarx',
    revenueVsCostSub: 'Tushum = tannarx + yalpi foyda',
    byBranch: 'Filiallar bo‘yicha tushum',
    byBranchSub: 'Tanlangan davrda filiallar ulushi',
    topProducts: 'Top 5 mahsulot',
    topProductsSub: 'Sotilgan dona bo‘yicha',
    productShare: 'Mahsulotlar ulushi',
    productShareSub: 'Sotilgan dona bo‘yicha taqsimot',
    others: 'Boshqalar',
    share: 'Ulush',
    totalUnits: 'jami dona',
    dailyProfit: 'Kunlik foyda o‘zgarishi',
    productProfit: 'Mahsulotlar bo‘yicha foyda',
    singleBranch: 'Filiallarni taqqoslash uchun “Barcha filiallar”ni tanlang',
  },
  tables: {
    recentDays: 'So‘nggi savdo kunlari',
    recentDaysSub: 'Kunlik tushum, sotuv va foyda',
    date: 'Sana',
    lowStock: 'Kam qolgan mahsulotlar',
    lowStockSub: 'Omborda {{count}} dona va undan kam qolganlar',
    remaining: 'Qoldiq',
    rowsTotal: '{{from}}–{{to}}, jami {{total}}',
  },
  states: {
    emptyTitle: 'Ma’lumot topilmadi',
    emptyPeriod: 'Tanlangan davrda savdo qayd etilmagan',
    emptyHint: 'Boshqa davr yoki filialni tanlab ko‘ring',
    emptySearch: 'Qidiruv bo‘yicha natija yo‘q',
    emptySearchHint: 'So‘rovni o‘zgartirib ko‘ring',
    errorTitle: 'Ma’lumotni yuklab bo‘lmadi',
    errorHint: 'Server bilan bog‘lanishda xatolik yuz berdi. Qayta urinib ko‘ring.',
  },
  checkout: {
    title: 'Kassa',
    subtitle: '{{branch}} bo‘yicha kunlik tushum',
    total: 'Davr bo‘yicha jami',
    avgDay: 'Kunlik o‘rtacha',
    bestDay: 'Eng yuqori kun',
    days: 'Savdo kunlari',
    daily: 'Kunlik tushum',
    dailySub: 'Har bir kun uchun kassadagi tushum',
  },
  reports: {
    title: 'Hisobotlar',
    titleFor: '{{branch}} hisoboti',
    subtitle: 'Mahsulotlar va kunlar kesimida sotuv',
    productName: 'Mahsulot nomi',
    quantity: 'Soni',
    profit: 'Foydasi',
    overall: 'Umumiy',
    total: 'Jami',
    exportName: 'hisobot',
  },
  createReport: {
    title: 'Hisobot yuborish',
    subtitle: 'Filial bo‘yicha kunlik sotilgan mahsulotlarni kiriting',
    branch: 'Filial',
    branchPlaceholder: 'Filialni tanlang',
    date: 'Sana',
    searchProduct: 'Mahsulot qidirish',
    searchPlaceholder: 'Mahsulot nomi',
    soldQuantity: 'Sotilgan soni',
    products: 'Mahsulotlar',
    filled: '{{count}} ta mahsulot kiritildi',
    totalUnits: 'Jami: {{count}} dona',
    negativeError: 'Sotilgan mahsulotlar soni 0 dan kichik bo‘lmasligi kerak',
    inStock: 'Omborda: {{count}}',
  },
  users: {
    title: 'Xodimlar',
    subtitle: 'Tizim foydalanuvchilari va ularning filiallari',
    add: 'Xodim qo‘shish',
    name: 'Xodim',
    branches: 'Biriktirilgan filiallar',
    noBranches: 'Filial biriktirilmagan',
    searchPlaceholder: 'Xodimni qidirish',
    createTitle: 'Yangi xodim',
    createSubtitle: 'Tizimga kirish uchun login va parol yarating',
    editTitle: 'Ma’lumotlarni yangilash',
    editSubtitle: 'Login, email va parolni o‘zgartirish',
    login: 'Login',
    loginPlaceholder: 'Loginni kiriting',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    emailHint: 'Parolni unutganda tasdiqlash kodi shu manzilga yuboriladi',
    emailInvalid: 'Email noto‘g‘ri kiritilgan',
    noEmail: 'Email kiritilmagan',
    emailMissingTitle: 'Email kiriting',
    emailMissingText: 'Email kiritilmagan. Parolni unutsangiz, uni tiklab bo‘lmaydi.',
    password: 'Parol',
    passwordPlaceholder: 'Parolni kiriting',
    newPasswordHint: 'Parolni o‘zgartirmasangiz, bo‘sh qoldiring',
    loginMin: 'Login kamida 4 ta belgidan iborat bo‘lsin',
    passwordMin: 'Parol kamida 4 ta belgidan iborat bo‘lsin',
    pages: 'Sahifalarga ruxsat',
    pagesHint: 'Xodim faqat belgilangan sahifalarni ko‘ra oladi',
    pagesRequired: 'Kamida bitta sahifani belgilang',
    count: '{{count}} ta xodim',
  },
  branches: {
    title: 'Filiallar',
    subtitle: 'Savdo nuqtalari, mas’ul xodimlar va narxlar',
    add: 'Filial qo‘shish',
    name: 'Filial nomi',
    namePlaceholder: 'Masalan: Chilonzor filiali',
    staff: 'Biriktirilgan xodimlar',
    staffPlaceholder: 'Xodimlarni tanlang',
    noStaff: 'Xodim biriktirilmagan',
    prices: 'Narxlar',
    reports: 'Hisobotlar',
    searchPlaceholder: 'Filialni qidirish',
    createTitle: 'Yangi filial',
    createSubtitle: 'Filial nomini kiriting va xodimlarni biriktiring',
    editTitle: 'Filialni tahrirlash',
    editSubtitle: 'Filial nomi va mas’ul xodimlar',
    pricesTitle: '{{branch}} — narxlar',
    pricesSubtitle: 'Filialdagi mahsulotlarning sotuv narxlari',
    editPrices: 'Narxlarni o‘zgartirish',
    editPricesTitle: '{{branch}} — narxlarni o‘zgartirish',
    editPricesSubtitle: 'Har bir mahsulot uchun sotuv narxini kiriting',
    sellPrice: 'Sotuv narxi',
    pricePlaceholder: 'Narx',
    count: '{{count}} ta filial',
  },
  products: {
    title: 'Sklad',
    subtitle: 'Mahsulotlar, qoldiqlar va filiallardagi narxlar',
    create: 'Yangi mahsulot',
    addStock: 'Kirim qilish',
    name: 'Mahsulot nomi',
    namePlaceholder: 'Mahsulot nomini kiriting',
    searchPlaceholder: 'Mahsulotni qidirish',
    stock: 'Qoldiq',
    buyPrice: 'Sotib olish narxi',
    buyPricePlaceholder: 'Narxni kiriting',
    quantity: 'Mahsulot miqdori',
    quantityPlaceholder: 'Miqdorni kiriting',
    branchPrices: 'Filiallardagi sotuv narxlari',
    branchPricesHint: 'Har bir filial uchun sotuv narxini kiriting',
    searchBranch: 'Filialni qidirish',
    sellPrice: 'Sotuv narxi',
    createTitle: 'Yangi mahsulot',
    createSubtitle: 'Mahsulot ma’lumotlari va filiallardagi narxlar',
    editTitle: 'Mahsulotni tahrirlash',
    editSubtitle: 'Mahsulot ma’lumotlari va filiallardagi narxlar',
    addStockTitle: 'Omborga kirim',
    addStockSubtitle: 'Har bir mahsulot uchun kelgan miqdorni kiriting',
    addQuantity: 'Kirim miqdori',
    currentStock: 'Hozirgi qoldiq: {{count}}',
    negativeError: 'Mahsulot soni 0 dan kichik bo‘lmasligi kerak',
    statusOk: 'Yetarli',
    statusLow: 'Kam qoldi',
    statusOut: 'Tugagan',
    count: '{{count}} ta mahsulot',
    filterAll: 'Barchasi',
    filterLow: 'Kam qolganlar',
    general: 'Asosiy ma’lumotlar',
  },
  confirm: {
    deleteTitle: 'O‘chirishni tasdiqlang',
    deleteText: 'Haqiqatan ham buni o‘chirmoqchimisiz? Bu amalni ortga qaytarib bo‘lmaydi.',
  },
  notify: {
    created: '{{entity}} muvaffaqiyatli yaratildi',
    updated: '{{entity}} muvaffaqiyatli yangilandi',
    deleted: '{{entity}} muvaffaqiyatli o‘chirildi',
    added: '{{entity}} muvaffaqiyatli qo‘shildi',
    createError: '{{entity}} yaratishda xatolik',
    updateError: '{{entity}} yangilashda xatolik',
    deleteError: '{{entity}} o‘chirishda xatolik',
    addError: '{{entity}} qo‘shishda xatolik',
    loginSuccess: 'Xush kelibsiz!',
    loginError: 'Login yoki parol noto‘g‘ri',
    logoutSuccess: 'Tizimdan chiqdingiz',
    logoutError: 'Chiqishda xatolik',
    entities: {
      user: 'Xodim',
      branch: 'Filial',
      product: 'Mahsulot',
      report: 'Hisobot',
      prices: 'Narxlar',
    },
  },
  validation: {
    required: '“{{field}}” maydoni to‘ldirilishi shart',
    min: 'Kamida {{count}} ta belgi kiriting',
    nonNegative: 'Qiymat 0 dan kichik bo‘lmasligi kerak',
    number: 'Raqam kiriting',
  },
  login: {
    title: 'Tizimga kirish',
    subtitle: 'Davom etish uchun hisobingizga kiring',
    login: 'Login',
    loginPlaceholder: 'Loginni kiriting',
    password: 'Parol',
    passwordPlaceholder: 'Parolni kiriting',
    submit: 'Kirish',
    forgotPassword: 'Parolni unutdingizmi?',
    asideTitle: 'Savdo avtomatlari tarmog‘ini bitta paneldan boshqaring',
    asideText: 'Tushum, ombor qoldiqlari va filiallar ko‘rsatkichlari real vaqtda.',
    feature1: 'Kunlik tushum va foyda tahlili',
    feature2: 'Ombor qoldig‘i nazorati',
    feature3: 'Filiallar bo‘yicha hisobotlar',
  },
  forgotPassword: {
    title: 'Parolni tiklash',
    subtitle: 'Hisobingizga bog‘langan emailni kiriting — unga 6 xonali tasdiqlash kodini yuboramiz',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    submit: 'Kod yuborish',
    backToLogin: 'Kirish sahifasiga qaytish',
    codeTitle: 'Kodni kiriting',
    codeText: '6 xonali tasdiqlash kodi quyidagi manzilga yuborildi:',
    codeHint: 'Kod 15 daqiqa amal qiladi. Xat kelmagan bo‘lsa, “Spam” papkasini tekshiring.',
    verify: 'Tasdiqlash',
    resend: 'Kodni qayta yuborish',
    resendIn: 'Qayta yuborish ({{count}} s)',
    changeEmail: 'Boshqa email kiritish',
  },
  resetPassword: {
    title: 'Yangi parol o‘rnatish',
    subtitle: 'Hisobingiz uchun yangi, ishonchli parol o‘ylab toping',
    password: 'Yangi parol',
    passwordPlaceholder: 'Yangi parolni kiriting',
    confirm: 'Parolni tasdiqlang',
    confirmPlaceholder: 'Parolni qayta kiriting',
    confirmRequired: 'Parolni qayta kiriting',
    mismatch: 'Parollar mos kelmadi',
    ruleLength: 'Kamida 8 ta belgi',
    ruleLetter: 'Kamida bitta harf',
    ruleDigit: 'Kamida bitta raqam',
    submit: 'Parolni saqlash',
    successTitle: 'Parol yangilandi',
    successText: 'Endi yangi parol bilan tizimga kirishingiz mumkin.',
  },
  errors: {
    network: 'Server bilan aloqa yo‘q. Internet aloqasini tekshiring',
    unknown: 'Kutilmagan xatolik yuz berdi. Qayta urinib ko‘ring',
    too_many_requests: 'Juda ko‘p urinish. Bir daqiqadan so‘ng qayta urinib ko‘ring',
    email_required: 'Emailni kiriting',
    email_invalid: 'Email noto‘g‘ri kiritilgan',
    email_email: 'Email noto‘g‘ri kiritilgan',
    email_max: 'Email juda uzun',
    email_unique: 'Bu email boshqa xodimga biriktirilgan',
    email_not_found: 'Bu email tizimda ro‘yxatdan o‘tmagan',
    mail_failed: 'Xatni yuborib bo‘lmadi. Birozdan so‘ng qayta urinib ko‘ring',
    login_required: 'Loginni kiriting',
    login_min: 'Login kamida 4 ta belgidan iborat bo‘lishi kerak',
    login_unique: 'Bu login band, boshqasini tanlang',
    password_required: 'Parolni kiriting',
    password_min: 'Parol kamida 4 ta belgidan iborat bo‘lishi kerak',
    password_weak: 'Parol kamida 8 ta belgi, harf va raqamdan iborat bo‘lishi kerak',
    user_not_found: 'Bunday foydalanuvchi topilmadi',
    wrong_password: 'Parol noto‘g‘ri',
    code_required: '6 xonali kodni to‘liq kiriting',
    code_invalid: 'Kod noto‘g‘ri. Emailga kelgan kodni tekshirib, qayta kiriting',
    code_expired: 'Kodning amal qilish muddati tugagan. Yangi kod so‘rang',
    code_attempts_exceeded: 'Juda ko‘p noto‘g‘ri urinish. Xavfsizlik uchun kod bekor qilindi — yangi kod so‘rang',
  },
  notFound: {
    title: 'Sahifa topilmadi',
    text: 'Siz qidirgan sahifa mavjud emas yoki ko‘chirilgan.',
    home: 'Bosh sahifaga qaytish',
  },
  errorBoundary: {
    title: 'Kutilmagan xatolik yuz berdi',
    text: 'Sahifani qayta yuklab ko‘ring. Muammo takrorlansa, administratorga murojaat qiling.',
    reload: 'Qayta yuklash',
  },
  table: {
    sortAsc: 'O‘sish bo‘yicha',
    sortDesc: 'Kamayish bo‘yicha',
    cancelSort: 'Saralashni bekor qilish',
  },
};

export default uz;
